import I18n from 'components/I18n'
import messages from 'lang'
import React from 'react'
import styled from 'styled-components'
import { color, fontSize } from 'utils/styledHelper'

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-around;
  height: 100%;
`

const Option = styled.a<{ disabled: boolean; selected: boolean }>`
  color: ${(p) => (p.selected ? color('blue400') : color('white'))};
  background: transparent;
  border: 0;
  font-weight: 600;
  font-size: ${fontSize('xs')};
  line-height: 150%;
  cursor: pointer;

  :hover {
    color: ${color('blue400')};
  }

  &[disabled] {
    color: ${color('dark400')};
  }
`

type PropType = {
  isPercentageDisabled: (percentage: number) => boolean
  onPercentageClick: (percentage: number) => void
  selected?: number
}

const PERCENTAGE_OPTIONS = [0.1, 0.25, 0.5, 0.75, 1]

const PercentagesDrawer = ({ isPercentageDisabled, onPercentageClick, selected }: PropType) => (
  <Wrapper>
    {PERCENTAGE_OPTIONS.map((percentage) => (
      <Option
        data-e2e={`ticketQuantityPercentageOption${String(percentage * 100)}`}
        disabled={isPercentageDisabled(percentage)}
        selected={percentage === selected}
        key={percentage}
        onClick={() => !isPercentageDisabled(percentage) && onPercentageClick(percentage)}
      >
        {percentage !== 1 ? (
          `${percentage * 100}%`
        ) : (
          <I18n data={messages.label_ticket_field_percetage_max} />
        )}
      </Option>
    ))}
  </Wrapper>
)

export default PercentagesDrawer
